'use client';

import React, { useLayoutEffect, useRef, useState } from 'react';

interface TooltipProps {
  text?: string;
  content?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  position?: 'top' | 'right' | 'bottom' | 'left';
  isCard?: boolean;
  width?: string;
}

const ToolTip: React.FC<TooltipProps> = ({
  text,
  content,
  children,
  className,
  position = 'right',
  isCard = false,
  width,
}) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const triggerRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (visible && triggerRef.current && tooltipRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();

      let top = 0;
      let left = 0;
      const gap = 10; // Fixed gap between icon and tooltip

      switch (position) {
        case 'top':
          top = triggerRect.top - tooltipRect.height - gap;
          left = triggerRect.left + triggerRect.width / 2;
          break;
        case 'right':
          top =
            triggerRect.top + triggerRect.height / 2 - tooltipRect.height / 2;
          left = triggerRect.right + gap; // Fixed gap from right edge of icon
          break;
        case 'bottom':
          top = triggerRect.bottom + gap;
          left = triggerRect.left + triggerRect.width / 2;
          break;
        case 'left':
          top =
            triggerRect.top + triggerRect.height / 2 - tooltipRect.height / 2;
          left = triggerRect.left - tooltipRect.width - gap;
          break;
      }

      setCoords({ top, left });
    }
  }, [visible, position]);

  return (
    <div
      ref={triggerRef}
      className={`relative group inline-block ${className || ''}`}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}

      {visible && (
        <div
          ref={tooltipRef}
          className={
            isCard
              ? `absolute z-10 invisible group-hover:visible bg-[#2F1869] text-white text-xs rounded px-4 py-3 left-1/2 transform -translate-x-1/2 max-w-[420px] top-[-50px] min-w-max`
              : `fixed z-50 text-white text-xs rounded pointer-events-none bg-[#2F1869] px-4 py-3 ${
                  className?.includes('tooltip-nowrap')
                    ? 'whitespace-nowrap max-w-none'
                    : className?.includes('tooltip-multiline')
                      ? 'whitespace-pre-line max-w-[460px]'
                      : 'max-w-[300px] min-w-auto whitespace-normal'
                } ${
                  position === 'top' ? '-translate-x-1/2' : ''
                } ${position === 'bottom' ? '-translate-x-1/2' : ''} ${
                  className?.includes('tooltip-wide')
                    ? 'max-w-[350px] min-w-auto'
                    : ''
                }`
          }
          // className={
          //   isCard
          //     ? `absolute z-10 invisible group-hover:visible bg-[#2F1869] text-white text-xs rounded px-4 py-3 left-1/2 transform -translate-x-1/2 max-w-[420px] top-[-50px] min-w-max`
          //     : `fixed z-50 text-white text-xs rounded pointer-events-none bg-[#2F1869] px-4 py-3 max-w-[300px] min-w-[200px] whitespace-normal ${
          //         position === 'top' ? '-translate-x-1/2' : ''
          //       } ${position === 'bottom' ? '-translate-x-1/2' : ''} ${
          //         className?.includes('tooltip-wide')
          //           ? 'max-w-[350px] min-w-[250px]'
          //           : ''
          //       }`
          // }
          style={
            isCard
              ? {}
              : {
                  top: coords.top,
                  left: coords.left,
                  ...(width ? { width } : {}),
                  textTransform: 'none',
                  textAlign: 'left',
                }
          }
        >
          {content ?? text}
          <div
            className={`absolute w-2 h-2 transform rotate-45 bg-[#2F1869] ${
              position === 'right'
                ? '-left-1 top-1/2 -translate-y-1/2'
                : position === 'left'
                  ? '-right-1 top-1/2 -translate-y-1/2'
                  : position === 'top'
                    ? 'bottom-[-4px] left-1/2 -translate-x-1/2'
                    : position === 'bottom'
                      ? 'top-[-4px] left-1/2 -translate-x-1/2'
                      : ''
            }`}
          />
        </div>
      )}
    </div>
  );
};

export default ToolTip;
